import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  h2 {
    display: inline-block;
    margin-bottom: 2rem;
    font-size: 3rem;
    margin-top: 0rem;
    color: var(--accent-text);
  }

  p {
    font-size: 1.7rem;
    line-height: 1.7;
    opacity: 0.9;
    margin-bottom: 1.6rem;
  }

  .skills {
    margin-top: 3.2rem;
  }

  .skill-row {
    display: grid;
    grid-template-columns: 14rem 1fr;
    gap: 1.6rem;
    align-items: baseline;
    padding: 1.4rem 0;
    border-top: 1px solid rgba(128, 128, 128, 0.3);

    dt {
      font-family: 'Red Hat Mono', monospace;
      font-size: 1.3rem;
      color: var(--accent-text);
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }

    dd {
      font-size: 1.5rem;
      line-height: 1.6;
      opacity: 0.85;
    }
  }

  .about-image {
    text-align: center;
    img {
      border-radius: 12px;
      margin-top: 2rem;
      width: 60%;
    }
  }

  @media only screen and (max-width: 480px) {
    .about-image {
      max-width: 100%;
      margin-top: 4rem;
    }
  }

  @media (max-width: 960px) {
    display: block;

    h2 {
      display: block;
      text-align: center;
    }

    .about-image {
      display: flex;
      justify-content: center;
      max-width: 100%;
    }
  }

  @media (max-width: 600px) {
    .skill-row {
      grid-template-columns: minmax(0, 1fr);
      gap: 0.4rem;
    }
  }
`;
